<template>
  <div class="inbox-section">
    <v-container class="d-flex justify-center align-center">
      <div class="card-wrapper">
        <v-expansion-panels multiple
        v-model="panel">
          <v-expansion-panel
            flat
            v-for="inbox in inboxes"
            :key="inbox.inb_id"
            class="inbox-card"
            :style="`border-left: 7px solid ${getBorderColor(inbox.inb_type)};`"
          >
            <v-expansion-panel-header>
              <v-row>
                <v-col xs="6" sm="6" md="6" cols="12">
                  <div>
                    <div class="caption grey--text">Subjek</div>
                    <div>
                      <router-link
                        v-if="inbox.inb_direct == 'BERKAS'"
                        to="/berkas"
                        class="a-link"
                        >{{ inbox.inb_subjek }}</router-link
                      >
                      <router-link
                        v-if="inbox.inb_direct == 'KARTU'"
                        to="/cetak-data"
                        class="a-link"
                        >{{ inbox.inb_subjek }}</router-link
                      >
                      <router-link
                        v-if="inbox.inb_direct == 'INFORMASI'"
                        :to="sw_status < 9 ? '/informasi' : '/profil-saya'"
                        class="a-link"
                        >{{ inbox.inb_subjek }}</router-link
                      >
                      <div v-if="inbox.inb_direct == '-'">
                        {{ inbox.inb_subjek }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="6" sm="6" md="3" cols="12">
                  <div class="caption grey--text">Tanggal terima</div>
                  <div>{{ formatInboxDate(inbox.inb_created_at) }}</div>
                </v-col>
                <v-col xs="6" sm="6" md="3" cols="12">
                  <div class="caption grey--text">Calon peserta didik</div>
                  <div>{{ student }}</div>
                </v-col>
              </v-row>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <div class="caption grey--text">Detail</div>
              <div>{{ inbox.inb_detail }}</div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="pa-5" v-if="!hasInbox">
          <v-container grid-list-xs py-5>
            <center>
              <p>Anda tidak memiliki kotak masuk.</p>
            </center>
          </v-container>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { EventBus } from '../event-bus';

export default {
  data: () => ({
    hasInbox: true,
    inboxes: [],
    student: '',
    sw_status: '',
    panel: [0],
  }),
  mounted() {
    this.getInbox();
  },
  methods: {
    async getInbox() {
      EventBus.$emit('startLoading');

      this.sw_status = localStorage.getItem("sw_status");

      const id = localStorage.getItem('id');

      const inboxRes = await axios.get(`${this.$api}/inbox?id=${id}`);
      const res = inboxRes.data;

      if (res.STATUS === 'SUCCESS') {
        this.student = res.MESSAGE;
        const inboxes = res.PAYLOAD;

        inboxes.forEach(inbox => {
          this.inboxes.push(inbox);
        });
      } else if (res.STATUS === 'ERROR' && res.MESSAGE === 'Tidak ada inbox!') {
        this.hasInbox = false;
      }

      EventBus.$emit('stopLoading');
    },

    getColor(inboxType) {
      if (inboxType === 'SUCCESS') return 'info';
      else if (inboxType === 'ERROR') return 'error';
      else if (inboxType === 'INFO') return 'warning';
      else return 'accentLightBlue';
    },

    getBorderColor(inboxType) {
      if (inboxType === 'SUCCESS') return '#3CD1C2';
      else if (inboxType === 'ERROR') return '#F83E70';
      else if (inboxType === 'INFO') return '#FFAA2C';
      else return '#2A429E';
    },

    formatInboxDate(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  }
};
</script>

<style scoped>
.inbox-section {
  min-height: 80vh;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.a-link {
  text-decoration: none;
  color: #2a429e;
}

.a-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 500px) {
  .card-wrapper {
    width: 80%;
  }
}
</style>
